module.exports = __webpack_public_path__ + "static/media/S1N1-6.be00ac9b.svg";